import type { Lead } from '@keyvue/one-api-client';
import { computed } from 'vue';
import useLeadSecurity from '@composables/security/useLeadSecurity';

export default function useLeadAttachmentSecurity(lead: Lead) {
    const { isUserOfAssignedCompany } = useLeadSecurity(lead);

    const canDelete = computed(() => isUserOfAssignedCompany);

    return {
        canDelete,
    };
}
